var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{attrs:{"label":"Agregar Nota","rows":"3"},model:{value:(_vm.comentario),callback:function ($$v) {_vm.comentario=$$v},expression:"comentario"}}),_c('submit-button',{attrs:{"text":"common.add","loading":_vm.loading},on:{"click":_vm.addNota}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }